import { z } from "zod"
import type { PreparationTask } from "./preparation-agent"

export const CONVERSATION_TURN_STATUS = {
  queued: "queued",
  running: "running",
  completed: "completed",
  blocked: "blocked",
  stopped: "stopped",
  failed: "failed",
} as const
export type ConversationTurnStatus =
  (typeof CONVERSATION_TURN_STATUS)[keyof typeof CONVERSATION_TURN_STATUS]
export const createConversationSchema = z.object({ id: z.string().uuid() }).strict()
export const conversationMessageSchema = z
  .object({
    id: z.string().uuid(),
    content: z.string().trim().min(1).max(4000),
    confirmedSharedContent: z.boolean(),
  })
  .strict()
export type ConversationMessage = {
  id: string
  role: "user" | "assistant"
  content: string
  createdAt: string
  runSlug: string | null
}
export type ConversationSummary = {
  id: string
  title: string
  preview: string
  createdAt: string
  updatedAt: string
  status: ConversationTurnStatus | "idle"
  runSlug: string | null
}
export type ConversationTurn = {
  id: string
  status: ConversationTurnStatus
  blocker: string | null
  runSlug: string | null
  preparationTaskId: string | null
}
export type ConversationSnapshot = {
  conversation: ConversationSummary
  messages: ConversationMessage[]
  activeTurn: ConversationTurn | null
  preparation: PreparationTask | null
  admissionEnabled: boolean
}
export type ConversationHistory = {
  conversations: ConversationSummary[]
  nextCursor: string | null
  admissionEnabled: boolean
}
